export default "__VITE_ASSET__C0Pb7g1Y__"